import { MapLayersState } from "./types";
import { MarkerIcons, BrokenMarkerIcons } from "@sureview/v2-mapping";

export function getDefaultState(): MapLayersState {
    return {
        MapLayer: {
            elevations: []
        },
        MapLayersBounds: [],
        MapLayersForGroup: [],
        MapSelectedElevation: 1,
        ManualRaiseMarkerPosition: null,
        ManualRaiseLayers: [],
        ManualRaiseSelectedLayer: null,
        MapItemIcons: MarkerIcons,
        BrokenMapItemIcons: BrokenMarkerIcons,
        LayersHidden: new Set<Number>(),
        Elevation: 1,
        ZoomLevel: "",
        MapLayersItemTypes: [],
        eventMarker: null,
        cancelTokenSource: null
    }
}